module.exports = require('../impls/object-keys/object-keys.js').objectKeys;